import { QuestionConfigValueApi } from "@stormwater-software/lib-inspection-templates";
import xhrService from "../api";
import { getOfflineQuestionConfigValues } from "../../db/db";
import { withOfflineFallback } from "../offlineFallback";

export const questionConfigValueApi: QuestionConfigValueApi = {
  // These are the select-one / select-many answer options. The download fetched
  // them and discarded the result, so offline the selects had no options.
  index: (questionId: number) =>
    withOfflineFallback(
      () =>
        xhrService
          .get(`/api/questions/${questionId}/config`)
          .then(res => res.data)
          .catch(error => {
            // `response` is absent on network-level failures; destructuring it
            // here replaced the real error with a TypeError.
            throw new Error(error?.response?.data?.message || error.message);
          }),
      () => getOfflineQuestionConfigValues(questionId),
    ),
};
